export default {
  isAdmin (state) {
    return state.roles.some(r => r === 'EMERGENCY.ADMIN')
  }
}
